import { createContext } from 'react'
import type { UserPagedQuery } from '../dtos'
import type { IPaginationContext } from '../interfaces/Pagination/Pagination'

export const userListContext = createContext<IPaginationContext<UserPagedQuery>>(
    {} as IPaginationContext<UserPagedQuery>)
